import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getDailyNews } from "../service";

export const useNewsData = (strategyId) => {
  const PAGE_SIZE = 100; // Backend fixed page size

  const queryResult = useInfiniteQuery({
    queryKey: ["dailyNews", strategyId || null],
    queryFn: ({ pageParam = 0 }) => getDailyNews(pageParam, strategyId),
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage) return undefined;

      // Prefer total from the first page, fallback to lastPage
      const firstPageTotal = allPages?.[0]?.total ?? lastPage?.total ?? 0;
      const currentPageCount = allPages.length; // number of pages fetched so far
      const totalPages = Math.ceil(firstPageTotal / PAGE_SIZE);

      // API uses zero-based page index; next page index equals pages fetched so far
      return currentPageCount < totalPages ? currentPageCount : undefined;
    },
    refetchOnMount: false,
    enabled: true,
  });

  // Flatten the paginated data
  const newsData =
    queryResult.data?.pages?.flatMap((page) => page?.news || []) || [];

  return {
    ...queryResult,
    news: newsData,
    total: queryResult.data?.pages?.[0]?.total || 0,
    pageSize: PAGE_SIZE,
  };
};
